<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="container-fluid">
                    <form id="FormRespuesta" role="form" method="post" autocomplete="off" onSubmit="return false">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                                <label class="form-label" for="Respuesta">Respuesta</label>
                                <input type="text" id="Respuesta" class="form-control" v-model="objConfigEncuestaRespuesta.Respuesta" placeholder="Agregar Respuesta">
                                <CValidation v-if="this.errorvalidacion.Respuesta" :Mensaje="'*'+errorvalidacion.Respuesta[0]"/>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label class="form-label" for="Valoracion">Valoracion</label>
                                <input @input="$onlyNums($event,objConfigEncuestaRespuesta,'Valoracion')" type="text" id="Valoracion" class="form-control" v-model="objConfigEncuestaRespuesta.Valoracion" placeholder="Agregar Valoracion">
                                <CValidation v-if="this.errorvalidacion.Valoracion" :Mensaje="'*'+errorvalidacion.Valoracion[0]"/>
                            </div>
                        </div>
                    </form>
                </div>
            </template>
        </CLoader>
    </div>
</template>

<script>

export default {
    name: 'FormRespuesta',
    props: ['poBtnSave','IdConfigEncuestaPregunta'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objConfigEncuestaRespuesta:{
                IdConfigEncuestaRespuesta:0,
                Respuesta:'',
                IdConfigEncuestaPregunta:0,
                Valoracion:'',
            },
            segurity: {},
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            MostrarTipoRespuesta:false
        }
    },
    methods: {
        async Guardar(){
            this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
            if (this.objConfigEncuestaRespuesta.IdConfigEncuestaRespuesta==0) {
                await this.$http.post('configEncuestaRespuestas/',this.objConfigEncuestaRespuesta
                ).then((res) => {
                    this.EjecutaConExito(res);
                }).catch((err) => {
                    this.EjecutaConError(err);
                });
            }
            else{
                await this.$http.put('configEncuestaRespuestas/'+this.objConfigEncuestaRespuesta.IdConfigEncuestaRespuesta,this.objConfigEncuestaRespuesta
                ).then((res) => {
                    this.EjecutaConExito(res);
                }).catch((err) => {
                    this.EjecutaConError(err);
                });
            }
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get('configEncuestaRespuestas/'+this.objConfigEncuestaRespuesta.IdConfigEncuestaRespuesta
            ).then((res)=>{
                this.objConfigEncuestaRespuesta=res.data.data;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar(){
            this.objConfigEncuestaRespuesta={
                IdConfigEncuestaRespuesta:0,
                Respuesta:'',
                IdConfigEncuestaPregunta:0,
                Valoracion:'',
            }
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            if (Id!='') 
            {
                this.objConfigEncuestaRespuesta.IdConfigEncuestaRespuesta = Id;
                this.Recuperar();
            }
            else
            {
                this.objConfigEncuestaRespuesta.IdConfigEncuestaPregunta=this.IdConfigEncuestaPregunta;
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>

<style>

</style>